<div class="form-group" [ngClass]="{ 'has-value': hasValue && AppControlType.Boolean !== type, 'mb-0': !margin }">
    @if (label && type !== AppControlType.Boolean && !(type === AppControlType.CodeList && multi)) {
        <label
            class="col-form-label"
            [ngClass]="{
                'label-star': !isDisabled && nullable === false,
                'disabled-bg': isDisabled
            }"
            [for]="property">
            {{ label }}
        </label>
    }

    @if (!static && type === AppControlType.String && !buttonIcon) {
        <input
            class="k-textbox form-control form-control-sm"
            type="text"
            kendoTextBox
            placement="top"
            placeholder="{{ placeholder }}"
            tooltipClass="error-tooltip"
            [attr.maxlength]="maxLength"
            [ngClass]="{ 'is-invalid': errors.length > 0 || isInvalid }"
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (keydown)="handleTextboxKeydown($event)"
            (focus)="multiSelectFocusInHandler($event)"
            (blur)="multiSelectFocusOutHandler($event)" />
    }

    @if (!static && type === AppControlType.String && buttonIcon) {
        <div class="input-group">
            @if (!static && type === AppControlType.String) {
                <input
                    class="k-textbox form-control form-control-sm"
                    type="text"
                    kendoTextBox
                    placement="top"
                    placeholder="{{ placeholder }}"
                    tooltipClass="error-tooltip"
                    [ngClass]="{ 'is-invalid': errors.length > 0 || isInvalid }"
                    [disabled]="isDisabled"
                    [(ngModel)]="value"
                    (keydown)="handleTextboxKeydown($event)"
                    (focus)="multiSelectFocusInHandler($event)"
                    (blur)="multiSelectFocusOutHandler($event)" />
            }
            @if (!static && type === AppControlType.String) {
                <span class="eye-icon" tabindex="0" kendoTooltip [title]="buttonTooltip">
                    <i class="fa" [ngClass]="buttonIcon" (click)="buttonClick()"></i>
                </span>
            }
        </div>
    }

    @if (!static && type === AppControlType.Textarea) {
        <textarea
            class="k-textarea form-control form-control-sm"
            type="text"
            #textareaEl
            rows="1"
            kendoTextArea
            placement="top"
            placeholder="{{ placeholder }}"
            tooltipClass="error-tooltip"
            [attr.maxlength]="maxLength"
            [autoSize]="true"
            [ngClass]="{
                'is-invalid': errors.length > 0 || isInvalid,
                'app-control-textarea--collapsed': collapsible && !textareaExpanded,
                'app-control-textarea--with-actions': collapsible && textareaNeedsCollapse
            }"
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (focus)="multiSelectFocusInHandler($event); onCollapsibleTextareaFocus()"
            (blur)="multiSelectFocusOutHandler($event); onCollapsibleFocusLeave($event)"></textarea>
    }

    @if (!static && type === AppControlType.Textarea && collapsible && textareaNeedsCollapse) {
        <app-textarea-actions
            #textareaActions
            [value]="value"
            [expanded]="textareaExpanded"
            (toggleExpanded)="toggleTextarea()"
            (focusout)="onCollapsibleFocusLeave($event)"></app-textarea-actions>
    }

    @if (!static && type === AppControlType.Password) {
        <div class="input-group">
            @if (!static && type === AppControlType.Password) {
                <input
                    class="k-textbox form-control form-control-sm"
                    kendoTextBox
                    placeholder="{{ placeholder }}"
                    placement="top"
                    tooltipClass="error-tooltip"
                    [type]="fieldTextType ? 'text' : 'password'"
                    [ngClass]="{ 'is-invalid': errors.length > 0 || isInvalid }"
                    [disabled]="isDisabled"
                    [autocomplete]="passwordAutocomplete"
                    [(ngModel)]="value"
                    (focus)="multiSelectFocusInHandler($event)"
                    (blur)="multiSelectFocusOutHandler($event)" />
            }
            @if (!static && type === AppControlType.Password) {
                <span class="eye-icon" tabindex="0">
                    <i
                        class="fa"
                        [ngClass]="{ 'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType }"
                        (click)="toggleFieldTextType()"></i>
                </span>
            }
        </div>
    }

    @if (!static && type === AppControlType.Number && decimal === false && year === false && forFilter === false) {
        <input
            class="form-control form-control-sm text-right"
            type="text"
            placeholder="{{ placeholder }}"
            placement="top"
            pattern="[0-9]"
            tooltipClass="error-tooltip"
            mask="separator.0"
            thousandSeparator="."
            [allowNegativeNumbers]="true"
            [ngClass]="{ 'is-invalid': errors.length > 0 || isInvalid }"
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (focus)="multiSelectFocusInHandler($event)"
            (blur)="multiSelectFocusOutHandler($event)" />
    }

    @if (!static && type === AppControlType.Number && decimal === false && year === true && forFilter === false) {
        <input
            class="form-control form-control-sm text-right"
            type="text"
            placeholder="{{ placeholder }}"
            placement="top"
            pattern="[0-9]"
            tooltipClass="error-tooltip"
            mask="separator.0"
            thousandSeparator=""
            [allowNegativeNumbers]="false"
            [ngClass]="{ 'is-invalid': errors.length > 0 || isInvalid }"
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (focus)="multiSelectFocusInHandler($event)"
            (blur)="multiSelectFocusOutHandler($event)" />
    }

    @if (!static && type === AppControlType.Number && decimal === true && forFilter === false) {
        <input
            class="form-control form-control-sm text-right"
            type="text"
            placeholder="{{ placeholder }}"
            step="0.01"
            placement="top"
            tooltipClass="error-tooltip"
            thousandSeparator="."
            decimalMarker=","
            [mask]="'separator.' + (roundNumberToPlaces || 3)"
            [allowNegativeNumbers]="true"
            [min]="min"
            [max]="max"
            [ngClass]="{ 'is-invalid': errors.length > 0 || isInvalid }"
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (focus)="multiSelectFocusInHandler($event)"
            (blur)="multiSelectFocusOutHandler($event)" />
    }

    @if (!static && type === AppControlType.Number && forFilter === true && decimal === false) {
        <input
            class="form-control form-control-sm"
            type="number"
            placeholder="{{ placeholder }}"
            placement="top"
            tooltipClass="error-tooltip"
            [ngClass]="{ 'is-invalid': errors.length > 0 || isInvalid }"
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (focus)="multiSelectFocusInHandler($event)"
            (blur)="multiSelectFocusOutHandler($event)" />
    }

    @if (!static && type === AppControlType.DateTime && kendoType === 'date') {
        <div [ngClass]="{ 'hide-picker-button': hidePickerButton }">
            @if (dateValue && !isDisabled) {
                <i
                    class="k-icon k-clear-value k-i-x date-time-close noborder"
                    placement="bottom"
                    [ngClass]="{ 'date-time-close-table': isInTable }"
                    (click)="dateValue = null"></i>
            }
            <kendo-datepicker
                class="k-datetimepicker noborder form-control form-control-sm pcs-control"
                #datePicker
                placeholder=""
                placement="top"
                tooltipClass="error-tooltip"
                format="dd.MM.yyyy"
                [navigation]="false"
                [ngClass]="{ 'is-invalid': errors.length > 0 || isInvalid }"
                [disabled]="isDisabled"
                [formatPlaceholder]="dateFormatPlaceholder"
                [popupSettings]="datePopupSettings"
                [(ngModel)]="dateValue"
                (valueChange)="dateTimePickerValueChange($event)"
                (focus)="multiSelectFocusInHandler($event)"
                (blur)="multiSelectFocusOutHandler($event)">
                <kendo-datetimepicker-messages
                    today="{{ 'Today' | translate }}"
                    dateTab="{{ 'Date' | translate }}"
                    timeTab="{{ 'Time' | translate }}"
                    now="{{ 'Now' | translate }}"
                    accept="{{ 'Accept' | translate }}"
                    cancel="{{ 'Cancel' | translate }}"></kendo-datetimepicker-messages>
            </kendo-datepicker>
        </div>
    }

    @if (!static && type === AppControlType.DateTime && kendoType === 'datetime') {
        <div [ngClass]="{ 'hide-picker-button': hidePickerButton }">
            @if (dateValue && !isDisabled) {
                <i
                    class="k-icon k-clear-value k-i-x date-time-close noborder"
                    placement="bottom"
                    [ngClass]="{ 'date-time-close-table': isInTable }"
                    (click)="dateValue = null"></i>
            }
            <kendo-datetimepicker
                class="k-datetimepicker noborder form-control form-control-sm pcs-control"
                #dateTimePicker
                placeholder=""
                placement="top"
                tooltipClass="error-tooltip"
                format="dd.MM.yyyy HH:mm"
                [ngClass]="{ 'is-invalid': errors.length > 0 || isInvalid }"
                [disabled]="isDisabled"
                [formatPlaceholder]="dateTimeFormatPlaceholder"
                [popupSettings]="datePopupSettings"
                [(ngModel)]="dateValue"
                (valueChange)="dateTimePickerValueChange($event)"
                (focus)="multiSelectFocusInHandler($event)"
                (blur)="multiSelectFocusOutHandler($event)">
                <kendo-datetimepicker-messages
                    today="{{ 'Today' | translate }}"
                    dateTab="{{ 'Date' | translate }}"
                    timeTab="{{ 'Time' | translate }}"
                    now="{{ 'Now' | translate }}"
                    accept="{{ 'Accept' | translate }}"
                    cancel="{{ 'Cancel' | translate }}"></kendo-datetimepicker-messages>
            </kendo-datetimepicker>
        </div>
    }

    @if (!static && type === AppControlType.DateTime && kendoType === 'time') {
        <div>
            @if (dateValue && !isDisabled) {
                <i
                    class="k-icon k-clear-value k-i-x date-time-close noborder"
                    placement="bottom"
                    [ngClass]="{ 'date-time-close-table': isInTable }"
                    (click)="dateValue = null"></i>
            }
            <kendo-timepicker
                class="noborder form-control form-control-sm pcs-control"
                placeholder=""
                placement="top"
                tooltipClass="error-tooltip"
                format="HH:mm"
                [ngClass]="{ 'is-invalid': errors.length > 0 || isInvalid }"
                [disabled]="isDisabled"
                [formatPlaceholder]="timeFormatPlaceholder"
                [popupSettings]="datePopupSettings"
                [(ngModel)]="dateValue"
                (focus)="multiSelectFocusInHandler($event)"
                (blur)="multiSelectFocusOutHandler($event)"></kendo-timepicker>
        </div>
    }

    <!-- <app-checkbox
  *ngIf="!static && type === AppControlType.Boolean"
  [size]="size"
  [(ngModel)]="value"
  [disabled]="isDisabled"
></app-checkbox> -->
    @if (type === AppControlType.Boolean) {
        <div class="d-flex align-items-center">
            <app-checkbox
                [label]="label"
                [tooltipTitle]="labelTooltip"
                [icon]="icon"
                [size]="size"
                [disabled]="isDisabled"
                [nullableCheckbox]="nullableCheckbox"
                [click]="click"
                [(ngModel)]="value"
                (keyup.enter)="onKeyUp($event)"></app-checkbox>
            @if (contextual) {
                <i
                    class="fa fa-info-circle h6 contextual-icon-inline"
                    kendoTooltip
                    title="{{ contextual | translate }}"
                    aria-hidden="true"></i>
            }
        </div>
    }
    @if (type === AppControlType.Static) {
        <div class="form-control-plaintext form-control-sm">
            {{ value }}
        </div>
    }

    @if (showFeedback && errors.length > 0) {
        <div class="invalid-feedback">
            {{ errors[0].errorMessage }}
        </div>
    }
    @if (contextual && type !== AppControlType.Boolean) {
        <i
            class="fa fa-info-circle h6 contextual-icon"
            kendoTooltip
            title="{{ contextual | translate }}"
            aria-hidden="true"></i>
    }
</div>
